/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import authorizedAxios from "../../apiJwtClient";
import {
  myBetsInitialState,
  TGetBetLegsRequest,
  TGetBetLegsResponse,
  TMyBetsResponse
} from "./myBetsTypes";

const configConst = (state: RootState) => state.config.data;

/*
 * Thunk to get the list of bets
 */
export const GetMyBets: any = createAsyncThunk(
  "getMyBets",
  async (type: number, { getState }): Promise<TMyBetsResponse> => {
    const config = configConst(getState() as RootState);

    const bets = await authorizedAxios.get(
      `${config.puntersApi}/api/MyBets/GetMyBets/${type}`
    );

    return { filterType: type, responseObject: bets.data.responseObject };
  }
);

/*
 * Thunk to get legs for a specific bet
 */
export const getBetLegs: any = createAsyncThunk(
  "getBetLegs",
  async (
    { betId }: TGetBetLegsRequest,
    { getState }
  ): Promise<TGetBetLegsResponse> => {
    const config = configConst(getState() as RootState);

    const betLegs = await authorizedAxios.get(
      `${config.puntersApi}/api/MyBets/GetBetLegs/${betId}`
    );

    return betLegs.data;
  }
);

const MyBetsSlice = createSlice({
  name: "MyBetsSlice",
  initialState: myBetsInitialState,
  reducers: {
    resetMyBetState: (state, action) => {
      return { ...state, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    // GetMyBets;
    builder.addCase(GetMyBets.pending, (state) => {
      state.noBetsFound = false;
      state.isFetchingMyBets = true;
    });
    builder.addCase(
      GetMyBets.fulfilled,
      (state, action: PayloadAction<TMyBetsResponse>) => {
        if (action.payload.filterType === 1) {
          state.openBets = action.payload.responseObject;
        } else if (action.payload.filterType === 0) {
          state.allSettledBets = action.payload.responseObject;
        } else if (action.payload.filterType === 4) {
          state.winBets = action.payload.responseObject;
        } else if (action.payload.filterType === 5) {
          state.lossBets = action.payload.responseObject;
        }
        state.noBetsFound =
          !action.payload.responseObject ||
          action.payload.responseObject.length === 0;
        state.isFetchingMyBets = false;
      }
    );
    builder.addCase(GetMyBets.rejected, (state) => {
      state.noBetsFound = true;
      state.isFetchingMyBets = false;
    });

    // GetBetLegs;
    builder.addCase(getBetLegs.pending, (state) => {
      state.isFetchingBetLegs = true;
    });
    builder.addCase(
      getBetLegs.fulfilled,
      (state, action: PayloadAction<TGetBetLegsResponse>) => {
        state.betLegs = action.payload.betLegs;
        state.isFetchingBetLegs = false;
      }
    );
    builder.addCase(getBetLegs.rejected, (state) => {
      state.isFetchingBetLegs = false;
    });
  }
});

export const { resetMyBetState } = MyBetsSlice.actions;

export default MyBetsSlice.reducer;
